import React from 'react';
import { toast as _toast } from 'react-toastify';
import SVG from 'react-inlinesvg';
import { checkCircleSVG } from './icons';
import styles from '../styles/notifications.module.scss';

export const toast = (message, toastId, type = 'default') => {
    if (_toast.isActive(toastId)) return;

    if (type === 'success') {
        _toast.success(
            <div className={styles.customToastSuccess}>
                <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                {message}
            </div>,
            {
                position: _toast.POSITION.TOP_RIGHT,
                className: styles.toast,
                toastId: toastId || message
            }
        );
        return;
    }

    _toast(message, {
        position: _toast.POSITION.TOP_RIGHT,
        className: 'toastify',
        toastId: toastId || message
    });
}
